import React, { useEffect, useMemo } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { ArrowLeftToLine, ArrowRightToLine, BriefcaseBusiness, LayoutPanelLeft, PencilRuler, RectangleEllipsis, Scale, Users, PocketKnife, LetterText, PanelsTopLeft } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { Menu, Menubar, Toast } from "lib/components"
import { appTools, cn } from "lib/utils"

const sidebaritems = [
  { name: "Clients", path: "/client", icon: <BriefcaseBusiness className="w-4 h-4 stroke-1" /> },
  { name: "Disputes", path: "/dispute?_page=1&_perpage=25&_sortby=title&_sortdir=desc", icon: <LayoutPanelLeft className="w-4 h-4 stroke-1" /> },  
  { name: "Conditionals", path: "/conditional", icon: <RectangleEllipsis className="w-4 h-4 stroke-1" /> },
  { name: "Content", path: "/content", icon: <LetterText className="w-4 h-4 stroke-1" /> },
  { name: "Layouts", path: "/layout", icon: <PanelsTopLeft className="w-4 h-4 stroke-1" />},
  { name: "Designs", path: "/design", icon: <PencilRuler className="w-4 h-4 stroke-1" />},
  { name: "Rules Engine", path: "/rules", icon: <Scale className="w-4 h-4 stroke-1" />, devonly: true },
  { name: "Users", path: "/user", icon: <Users className="w-4 h-4 stroke-1" /> },
  { name: "Dev Tools", path: "/devtools", icon: <PocketKnife className="w-4 h-4 stroke-1" /> },
]

const getTopbarMenu = (methods:any, navigate:any) => [
  { 
    refstr: "feedback", 
    label: "Feedback",
    submenus: [
      { type: "option", refstr: "submit-feedback", label: "Submit New Item", selectFn: methods.submitFeedback },
      { type: "option", refstr: "view-feedback", label: "View My Open Items", selectFn: methods.viewOpenFeedback },
    ]
  },
  { 
    refstr: "help", 
    label: "Help",
    submenus: [
      { type: "option", refstr: "show-help", label: "Show Help Console", selectFn: methods.showHelpConsole }
    ]
  },
  { 
    refstr: "logout", 
    label: "Logout",
    edge: "right",
    submenus: [
      { type: "option", refstr: "logout", label: "Logout", selectFn: () => navigate("/?logout=true") }
    ]
  }
]

export default function AdminWrapper({ children }:any){

  const navigate = useNavigate()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  function handleNavClick(path:string){
    navigate(path)
  }

  const menus = useMemo(() => getTopbarMenu({
    submitFeedback: () => update("ui.feedback.open", true),
    viewOpenFeedback: () => update("ui.feedback.open", true),
    showHelpConsole: () => update("ui.help.open", true),
  }, navigate), [store.ui.feedback.open, store.ui.help.open])

  const sidebarItemsToDisplay = useMemo( () => {
    return sidebaritems.filter( (item:any) => {
      if( process.env.NODE_ENV !== "production" ) return true 
      if( item.devonly === true ) return false
      return true
    })
  },[ sidebaritems, process.env.NODE_ENV ])

  useEffect(() => {
    if( !store.user ){
      console.log("no user found, redirecting to login")
      // navigate("/")
    }
  },[store.user])

  // useEffect(() => {
  //   console.log(process.env.FAST_REFRESH)
  //   console.log(store.sidebar)
  // },[store.sidebar])

  // if( !appState.user ) return <></>
  return (
    <div className="w-screen h-screen overflow-x-hidden scrollbar">

      { store.ui.mask === true ? (
        <div className="mask modal-mask w-screen h-screen bg-neutral-900 opacity-80 z-10">
          <Toast />
        </div>
      ):(
        <Toast />
      )}

      <div 
        className={cn(
          "fixed top-0 left-0 h-screen bg-slate-800 flex flex-col border-r border-solid border-slate-700",
          store.ui.sidebar.expanded === true ? "w-[10rem]" : "w-[3rem]"
        )}
      >
        <div className="w-full h-8 flex justify-between items-center px-2 text-sm bg-teal-900 mb-4 ">
          { store.ui.sidebar.expanded === true && ( <span className="pl-5 uppercase tracking-widest text-white">Admin</span> ) }
          { store.ui.sidebar.expanded === true 
            ? <ArrowLeftToLine className="w-5 h-5 stroke-1 cursor-1" onClick={() => update("ui.sidebar.expanded", false)} /> 
            : <ArrowRightToLine className="w-5 h-5 stroke-1 cursor-1" onClick={() => update("ui.sidebar.expanded", true)} /> 
          }  
        </div>
        { sidebarItemsToDisplay.map( (item:any) => (
          <div 
            key={item.name} 
            onClick={() => handleNavClick(item.path)}
            className="w-full h-8 text-xs uppercase tracking-wide flex justify-start items-center px-4 hover:bg-slate-700 cursor-pointer"
          >
            { item.icon }
            { store.ui.sidebar.expanded === true && (
              <span className="px-3">{item.name}</span>
            )}
          </div>
        ))}

        </div>
      <div 
        className={cn(
          "w-[calc(100%-10rem)] h-screen flex flex-col",
          store.ui.sidebar.expanded === true ? "ml-[10rem] w-[calc(100%-10rem)]" : "ml-[3rem] w-[calc(100%-3rem)]"
        )}
      >
        <div 
          className={cn(
            "fixed top-0 h-[2rem] bg-slate-800 text-white w-full flex justify-start items-center px-4 border-b border-solid border-neutral-700",
            store.ui.sidebar.expanded === true ? "left-[10rem]  w-[calc(100vw-10rem)]" : "left-[3rem] w-[calc(100vw-3rem)]"
          )}>
            <Menubar config={{ size: "lg" }} className="justify-end gap-3" menus={menus} />
        </div>

        <div className="w-full p-6">
          <Outlet />
        </div>
      </div>

      {/* <Toast /> */}
    </div>
  )

}